Vendd.Scripts.load(function () {

    $('.x-photogallery.x-photogallery-carousel.document-gallery').each(function (i, wrapper) {
        if (!$(wrapper).data('init'))
            return;

        var $wrapper = $(wrapper);
        var $normalWrapper = $('.photogallery-normal > ul', $wrapper);
        var $thumbsWrapper = $('.photogallery-thumbs > ul', $wrapper);
        
        var fbOpts = {
            protect: true,
            infobar: true
        };
       
        initCarousel($normalWrapper[0], $thumbsWrapper[0]);
        $('.fancylink', $wrapper).fancybox(fbOpts);
                     
    });

    function initCarousel(items, pager) {
        var sync1 = $(items);
        var sync2 = $(pager);

        var opts, thumbOpts;

        opts = {
            singleItem: true,
            slideSpeed: 1000,
            navigation: true,
            pagination: true,
            navigationText: ["<span class='icon icon-arrow-left'></span>", "<span class='icon icon-arrow-right'></span>"],
            rewindNav: true,
            transitionStyle : "fade",
            afterAction: syncPosition,
            responsiveRefreshRate: 200,
            afterInit: syncPosition
        }

        thumbOpts = {
            items: 5,
            itemsDesktop: [1366, 5],
            itemsDesktopSmall: [1100, 5],
            itemsTablet: [768, 5],
            itemsMobile: [479, 5],
            pagination: false,
            navigation: true,
            scrollPerPage: true,
            navigationText: ["<span class='icon icon-arrow-left'></span>", "<span class='icon icon-arrow-right'></span>"],
            rewindNav: false,
            responsiveRefreshRate: 100,
            afterInit: function (el) {
                var owlItems = el.find(".owl-item");

                owlItems.eq(0).addClass("synced");
            }
        }       

        sync1.owlCarousel(opts);

        sync2.owlCarousel(thumbOpts);

        $(pager).on("click", ".owl-item", function (e) {
            e.preventDefault();

            var number = $(this).data("owlItem");
            sync1.trigger("owl.goTo", number);
        });

        function syncPosition(el) {
            var current = this.currentItem;

            var owlItems = $(pager).find(".owl-item");

            owlItems
                .removeClass("synced")
                .eq(current)
                .addClass("synced")

            if ($(pager).data("owlCarousel") !== undefined) {
                center(current)
            }
        }

        function center(number) {
            var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
            var num = number;
            var found = false;
            for (var i in sync2visible) {
                if (num === sync2visible[i]) {
                    var found = true;
                }
            }

            if (found === false) {
                if (num > sync2visible[sync2visible.length - 1]) {
                    sync2.trigger("owl.goTo", num - sync2visible.length + 2)
                } else {
                    if (num - 1 === -1) {
                        num = 0;
                    }
                    sync2.trigger("owl.goTo", num);
                }
            } else if (num === sync2visible[sync2visible.length - 1]) {
                sync2.trigger("owl.goTo", sync2visible[1])
            } else if (num === sync2visible[0]) {
                sync2.trigger("owl.goTo", num - 1)
            }
        }
    }
});